import { defineComponent, ref } from 'vue';
import __vue_component__$2 from '../../../../../../alerts/Pane/Pane.vue.js';
import __vue_component__$1 from '../../../../../../buttons/ButtonComponent/ButtonComponent.vue.js';
import __vue_component__ from '../../../../../../cards/BasicCard/BasicCard.vue.js';

var script = defineComponent({
    name: 'ChartingTubeLabelConfirm',
    components: {
        BasicCard: __vue_component__,
        ButtonComponent: __vue_component__$1,
        Pane: __vue_component__$2,
    },
    props: {
        isOpened: {
            type: Boolean,
            required: true,
        },
    },
    emits: ['labelingConfirmed', 'update:isOpened'],
    setup: (_, { emit }) => {
        const confirmed = ref(false);
        const paneRef = ref();
        /**
         * Handles the confirmation of tube labeling.
         *
         * - Sets confirmed.value that will later be emitted to the parent component
         * - Closes the modal via manually calling the closeModal method to avoid
         *   emitting the close event twice
         */
        const handleLabelingConfirmed = (conf) => {
            var _a;
            confirmed.value = conf;
            if (!((_a = paneRef.value) === null || _a === void 0 ? void 0 : _a.closeModal))
                return;
            paneRef.value.closeModal();
        };
        /**
         * Handles logic once the modal is about to close
         *
         * - Emits the labeling confirmation to the parent component
         * - Resets the confirmed.value to false for later openings of the modal
         * - Emits the update:isOpened event to close the modal
         *
         * This setup is necessary since we need to have the same functionality between
         * the unconfirmation button and the top right pane button while also knowing that
         * the close event will be emitted when either of the button events are triggered
         */
        const handleClose = () => {
            emit('labelingConfirmed', confirmed.value);
            confirmed.value = false;
            emit('update:isOpened', false);
        };
        return {
            paneRef,
            handleClose,
            handleLabelingConfirmed,
        };
    },
});

export { script as default };
